import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { User } from '../models/user';
import { ParameterConst } from '../util/constant';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        var sessionStr = localStorage.getItem(ParameterConst.USER_LOGIN);
        var user: User = (sessionStr) ? <User>JSON.parse(sessionStr) : null;

        if (user != null) {
            
            //validar si el usuario tiene en LS el listado de tematicas
            
            return true;


        } else {
            this.router.navigate(['/']);
        }
        
    }
}